/**
 * Precio de un producto, con su precio de lista tachado cuando esta en oferta.
 *
 * El precio anterior se marca con `<s>` y se le pone un texto para lector de
 * pantalla: un numero tachado sin explicacion no se entiende en audio.
 */
import { pesos, porcentajeDescuento } from '../../utilidades/formato';

export interface PrecioProps {
  precio: number;
  precioAnterior: number | null;
  /** `grande` en la ficha, `normal` en las tarjetas del listado. */
  tamano?: 'normal' | 'grande';
}

export function Precio({ precio, precioAnterior, tamano = 'normal' }: PrecioProps) {
  const descuento = porcentajeDescuento(precio, precioAnterior);
  const grande = tamano === 'grande';

  return (
    <div className={grande ? 'ficha-precio' : 'tarjeta-precios'}>
      <span className={grande ? 'p' : 'precio'}>{pesos(precio)}</span>
      {descuento !== null && precioAnterior !== null ? (
        <s className={grande ? 'pa' : 'precio-antes'}>
          <span className="solo-lectores">Precio anterior: </span>
          {pesos(precioAnterior)}
        </s>
      ) : null}
      {grande && descuento !== null && precioAnterior !== null ? (
        <span className="etq etq-oferta">Ahorras {pesos(precioAnterior - precio)}</span>
      ) : null}
    </div>
  );
}
